import jwtDecode from "jwt-decode";

const isAccessTokenExpired = (
  jwtAccessToken: string, 
  skipDecoding?: boolean  // unit testing purposes only
): undefined | boolean  => {
  if (!jwtAccessToken) {
    console.warn('A valid token must be provided!');
    return;
  }

  const decodedToken: any = skipDecoding? jwtAccessToken : jwtDecode(jwtAccessToken);
  if(!decodedToken || !decodedToken?.exp) {
    return true;
  }

  return decodedToken?.exp && (Date.now() >= (decodedToken.exp * 1000));
}

export default isAccessTokenExpired;